/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmailSettingsResponse } from '../models/email-settings-response';
import { EmailSettingsStatusResponse } from '../models/email-settings-status-response';
import { getEmailSettings } from '../fn/notification-settings/get-email-settings';
import { GetEmailSettings$Params } from '../fn/notification-settings/get-email-settings';
import { getEmailSettingsStatus } from '../fn/notification-settings/get-email-settings-status';
import { GetEmailSettingsStatus$Params } from '../fn/notification-settings/get-email-settings-status';
import { getNotificationSetting } from '../fn/notification-settings/get-notification-setting';
import { GetNotificationSetting$Params } from '../fn/notification-settings/get-notification-setting';
import { NotificationSettingsResponse } from '../models/notification-settings-response';
import { updateEmailSettings } from '../fn/notification-settings/update-email-settings';
import { UpdateEmailSettings$Params } from '../fn/notification-settings/update-email-settings';
import { updateNotificationSetting } from '../fn/notification-settings/update-notification-setting';
import { UpdateNotificationSetting$Params } from '../fn/notification-settings/update-notification-setting';
import { updateNotificationSettingCredentials } from '../fn/notification-settings/update-notification-setting-credentials';
import { UpdateNotificationSettingCredentials$Params } from '../fn/notification-settings/update-notification-setting-credentials';

@Injectable({ providedIn: 'root' })
export class NotificationSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateNotificationSettingCredentials()` */
  static readonly UpdateNotificationSettingCredentialsPath = '/tenants/{tenantId}/notification-settings/{notificationType}/credentials';

  /**
   * Update Tenant level SMS Notification Settings Credentials.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotificationSettingCredentials()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationSettingCredentials$Response(params: UpdateNotificationSettingCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateNotificationSettingCredentials(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Tenant level SMS Notification Settings Credentials.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotificationSettingCredentials$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationSettingCredentials(params: UpdateNotificationSettingCredentials$Params, context?: HttpContext): Observable<void> {
    return this.updateNotificationSettingCredentials$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotificationSetting()` */
  static readonly GetNotificationSettingPath = '/tenants/{tenantId}/notification-settings/{notificationType}';

  /**
   * Get Tenant level Notification Settings (SMS, PUSH).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationSetting$Response(params: GetNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSettingsResponse>> {
    return getNotificationSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tenant level Notification Settings (SMS, PUSH).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationSetting(params: GetNotificationSetting$Params, context?: HttpContext): Observable<NotificationSettingsResponse> {
    return this.getNotificationSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationSettingsResponse>): NotificationSettingsResponse => r.body)
    );
  }

  /** Path part for operation `updateNotificationSetting()` */
  static readonly UpdateNotificationSettingPath = '/tenants/{tenantId}/notification-settings/{notificationType}';

  /**
   * Update Tenant level Notification Settings (SMS, PUSH).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotificationSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationSetting$Response(params: UpdateNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateNotificationSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Tenant level Notification Settings (SMS, PUSH).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotificationSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationSetting(params: UpdateNotificationSetting$Params, context?: HttpContext): Observable<void> {
    return this.updateNotificationSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEmailSettings()` */
  static readonly GetEmailSettingsPath = '/tenants/{tenantId}/email-settings';

  /**
   * Get Tenant level Transactional Email Settings.
   *
   * Returns whether custom templates are enabled, sender addresses, date/time formats, the Acoustic template of each email, the setup status and the TMS provider.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEmailSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmailSettings$Response(params: GetEmailSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailSettingsResponse>> {
    return getEmailSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tenant level Transactional Email Settings.
   *
   * Returns whether custom templates are enabled, sender addresses, date/time formats, the Acoustic template of each email, the setup status and the TMS provider.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEmailSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmailSettings(params: GetEmailSettings$Params, context?: HttpContext): Observable<EmailSettingsResponse> {
    return this.getEmailSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailSettingsResponse>): EmailSettingsResponse => r.body)
    );
  }

  /** Path part for operation `updateEmailSettings()` */
  static readonly UpdateEmailSettingsPath = '/tenants/{tenantId}/email-settings';

  /**
   * Update Tenant level Transactional Email Settings.
   *
   * Replaces the whole transactional email settings.
   * With customTemplatesEnabled true, the request must contain the whole custom configuration: fromAddress, noReplyAddress, dateFormat, timeFormat,
   * and emailMappings with at least one mapped email. It sets setupStatus to IN_PROGRESS.
   * The brand's Acoustic credentials are not part of the request: they must already be configured with PUT /secrets/{secretName}
   * (acoustic_databaseid, acoustic_clientid, acoustic_clientsecret, acoustic_refreshtoken and acoustic_pod).
   * The request is rejected with a 400 while any of them is missing or invalid.
   * With customTemplatesEnabled false, the request must contain only the flag: the settings are reset to the defaults. The Acoustic secrets are kept.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmailSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmailSettings$Response(params: UpdateEmailSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEmailSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Tenant level Transactional Email Settings.
   *
   * Replaces the whole transactional email settings.
   * With customTemplatesEnabled true, the request must contain the whole custom configuration: fromAddress, noReplyAddress, dateFormat, timeFormat,
   * and emailMappings with at least one mapped email. It sets setupStatus to IN_PROGRESS.
   * The brand's Acoustic credentials are not part of the request: they must already be configured with PUT /secrets/{secretName}
   * (acoustic_databaseid, acoustic_clientid, acoustic_clientsecret, acoustic_refreshtoken and acoustic_pod).
   * The request is rejected with a 400 while any of them is missing or invalid.
   * With customTemplatesEnabled false, the request must contain only the flag: the settings are reset to the defaults. The Acoustic secrets are kept.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEmailSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEmailSettings(params: UpdateEmailSettings$Params, context?: HttpContext): Observable<void> {
    return this.updateEmailSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEmailSettingsStatus()` */
  static readonly GetEmailSettingsStatusPath = '/tenants/{tenantId}/email-settings/status';

  /**
   * Get Tenant level custom Transactional Email templates status.
   *
   * Returns whether the tenant has custom templates enabled and the provisioning status of the TMS provider and of each email, without the custom configuration (sender addresses, formats and Acoustic templates).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEmailSettingsStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmailSettingsStatus$Response(params: GetEmailSettingsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailSettingsStatusResponse>> {
    return getEmailSettingsStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tenant level custom Transactional Email templates status.
   *
   * Returns whether the tenant has custom templates enabled and the provisioning status of the TMS provider and of each email, without the custom configuration (sender addresses, formats and Acoustic templates).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEmailSettingsStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmailSettingsStatus(params: GetEmailSettingsStatus$Params, context?: HttpContext): Observable<EmailSettingsStatusResponse> {
    return this.getEmailSettingsStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailSettingsStatusResponse>): EmailSettingsStatusResponse => r.body)
    );
  }

}
